import React, { Component } from "react";
import "../style/sign.scss";
export default class IframeComponent extends Component {
  render() {
      return (
        <div className="has-background-light">
        <iframe
          src={this.props.src}
          height={this.props.height}
          width={this.props.width}
          className="fullheight has-background-light" //overflow="hidden"
        />
      </div>
    );
  }
}
